// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contains info about a token
 * @export
 * @interface TokenDetails
 */
export interface TokenDetails {
    /**
     * 
     * @type {string}
     * @memberof TokenDetails
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TokenDetails
     */
    decimals: number;
    /**
     * 
     * @type {string}
     * @memberof TokenDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TokenDetails
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof TokenDetails
     */
    type: string;
}

/**
 * Check if a given object implements the TokenDetails interface.
 */
export function instanceOfTokenDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "decimals" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "symbol" in value;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function TokenDetailsFromJSON(json: any): TokenDetails {
    return TokenDetailsFromJSONTyped(json, false);
}

export function TokenDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'decimals': json['decimals'],
        'name': json['name'],
        'symbol': json['symbol'],
        'type': json['type'],
    };
}

export function TokenDetailsToJSON(value?: TokenDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'decimals': value.decimals,
        'name': value.name,
        'symbol': value.symbol,
        'type': value.type,
    };
}

